@if (proration(); as proration) {
  <div class="pricing-lines">
    @for (line of proration.lines; track line) {
      <div class="price-line">
        @if (line.type === 'invoiceitem') {
          <div class="line-key" [appTooltip]="line.description">
            {{ line.description }}
          </div>
        }
        @if (line.type === 'subscription') {
          <div class="line-key">
            <b>{{ line.description }}</b>
          </div>
        }
        <div class="line-value">
          {{ line.amount / 100 | customCurrency }}
        </div>
      </div>
    }
    <div class="price-divider"></div>
    @if (proration.subTotal !== proration.amount_due) {
      <div class="price-line sub-total">
        <div class="line-key">Subtotal</div>
        <div class="line-value">{{ proration.subTotal / 100 | customCurrency }}</div>
      </div>
    }
    @if (proration.discount) {
      <div class="price-line discount">
        <div class="line-key">{{ proration.discount.promo.name }}</div>
        <div class="line-value">{{ -proration.totalDiscount / 100 | customCurrency }}</div>
      </div>
    }
    @if (proration.usedBalance) {
      <div class="price-line used-balance">
        <div class="line-key">Applied balance</div>
        <div class="line-value">{{ proration.usedBalance / 100 | customCurrency }}</div>
      </div>
    }
    <div class="price-line total">
      <div class="line-key"><b>Total</b></div>
      <div class="line-value">{{ proration.amount_due / 100 | customCurrency }}</div>
    </div>
  </div>
}
